import { DATE_BOX_CONTROLS_SERVICE_NAME, DateBoxControlsServiceProvider } from './date-box.controls.service'
import { SELECT_BOX_CONTROLS_SERVICE_NAME, SelectBoxControlsServiceProvider } from './select-box.controls.service'
import { UTILS_CONTROLS_SERVICE_NAME, UtilsControlsServiceProvider } from './utils.controls.service'
import { VALIDATION_CONTROLS_SERVICE_NAME, ValidationControlsServiceProvider } from './validation.controls.service'

export const CONTROLS_SERVICES_MODULE_NAME = 'simax.services.controls'

const module = angular.module(CONTROLS_SERVICES_MODULE_NAME, [])

module.provider(DATE_BOX_CONTROLS_SERVICE_NAME, DateBoxControlsServiceProvider)
module.provider(SELECT_BOX_CONTROLS_SERVICE_NAME, SelectBoxControlsServiceProvider)
module.provider(UTILS_CONTROLS_SERVICE_NAME, UtilsControlsServiceProvider)
module.provider(VALIDATION_CONTROLS_SERVICE_NAME, ValidationControlsServiceProvider)
